import { DaysOfTheWeek } from 'src/replicant/utils/time';
import { Match2Reward } from '../rewards/match2-rewards.ruleset';

export type BotEventType = 'onHeartbeat' | 'onPlayerScored';

export type TimedRaceGoal = 'level' | 'lollipop';
export type TimedRaceTheme = 'sugar' | 'crown';
export type TimedRaceConfig = {
  type: 'time';
  theme: TimedRaceTheme;
  goal: TimedRaceGoal;
  raceDurationHours: number;
};

export type TargetRaceTheme = 'turtle';
export type TargetRaceGoal = 'level';
export type TargetRaceConfig = {
  type: 'target';
  theme: TargetRaceTheme;
  goal: TargetRaceGoal;
  target: number;
};

export type RaceConfig = TimedRaceConfig | TargetRaceConfig;
export type RaceGoal = TimedRaceGoal | TargetRaceGoal;
export type RaceType = RaceConfig['type'];

export const racesConfig = {
  levelRush: {
    type: 'time',
    theme: 'crown',
    goal: 'level',
    raceDurationHours: 1,
  },
  sugarRush: {
    type: 'time',
    theme: 'sugar',
    goal: 'lollipop',
    raceDurationHours: 1,
  },
  turtle: {
    type: 'target',
    theme: 'turtle',
    goal: 'level',
    target: 15,
  },
} satisfies Record<string, RaceConfig>;

export type RaceConfigId = keyof typeof racesConfig;
export const raceSchedule: Record<DaysOfTheWeek, RaceConfigId | null> = {
  monday: 'levelRush',
  tuesday: 'sugarRush',
  wednesday: 'levelRush',
  thursday: 'sugarRush',
  friday: 'turtle',
  saturday: 'turtle',
  sunday: 'turtle',
};

export const scoreFactors: Record<
  RaceType,
  Record<TimedRaceGoal, number> | Record<TargetRaceGoal, number>
> = {
  time: { level: 1, lollipop: 40 },
  target: { level: 1 },
};
export const botCount = 4;
export const raceUnlockLevel = 32;
export const lollipopLimit = 81;

export const rewardsConfig: Record<RaceType, Match2Reward[][]> = {
  time: [[{ type: 'gems', amount: 400 }], [{ type: 'gems', amount: 200 }]],
  target: [
    [{ type: 'gems', amount: 400 }],
    [{ type: 'gems', amount: 100 }],
    [{ type: 'gems', amount: 50 }],
  ],
};

export type BotType = 'default' | 'competitive' | 'dud';
export const botCompositions: BotType[][] = [
  ['competitive', 'competitive', 'default', 'dud'],
  ['competitive', 'default', 'default', 'dud'],
  ['competitive', 'competitive', 'competitive', 'dud'],
];
export const botCompositionsV2: BotType[][] = [
  ['competitive', 'competitive', 'default', 'dud'],
  ['competitive', 'default', 'default', 'default'],
  ['competitive', 'competitive', 'competitive', 'dud'],
  ['default', 'default', 'default', 'dud'],
];
